import { Component, OnInit } from '@angular/core';
import { SocialChallengeBloc } from '@kf-sc';
import { TitleService } from '@kservice';
import { SocialChallenge, SocialChallengeState, Status } from '@ktypes/models';

@Component({
  selector: 'kp-screen-challenges',
  templateUrl: './screen-challenges.component.html',
  styleUrls: ['./screen-challenges.component.scss'],
})
export class ScreenChallengesComponent implements OnInit {
  private _title = 'Challenges';
  challengeState = SocialChallengeState;
  status = Status;
  constructor(public socialChallengeBloc: SocialChallengeBloc, private _titleService: TitleService) {}

  ngOnInit() {
    this._titleService.set(this._title);
    this.socialChallengeBloc.getChallenges(false);
  }

  trackByChallengeId(index: number, challenge: SocialChallenge): string {
    return challenge.id;
  }
}
